import { handleActions } from 'redux-actions'
import * as constants from './constants'

function getCMSEnvironment() {
  try {
    return sessionStorage.getItem(constants.CMS_ENVIRONMENT_SESSION_STORAGE_KEY)
  } catch (error) {
    return null
  }
}

const initialState = {
  preview: window.location.search.includes('preview=true'),
  cmsEnvironment: getCMSEnvironment()
}

export default handleActions(
  {
    [constants.SET_CMS_ENVIRONMENT]: (state, { payload }) => ({
      ...state,
      cmsEnvironment: payload
    })
  },
  initialState
)
